var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardLayout',[_c('TableComponent',{attrs:{"title":'Campaigns',"data":_vm.campaigns,"heading":_vm.heading,"buttonTitle":'See all campaigns',"view":'page',"loading":_vm.loading,"type":'campaign'},on:{"handleClick":_vm.handleClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }